<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <MutationPreinscription
              v-if="
                preinscription.data.formulaire
                  .licencePreinscriptionFormulaireEtape.numeroEtape === 2
              "
              :preinscription="preinscription"
              :token="token"
            />

            <GestionASTTPreinscription
              v-if="
                preinscription.data.formulaire
                  .licencePreinscriptionFormulaireEtape.numeroEtape === 9 &&
                  preinscription.data.statut === 'AE'
              "
              :preinscription="preinscription"
              :token="token"
            />

            <horizontal-stepper
              v-if="
                preinscription.data.formulaire
                  .licencePreinscriptionFormulaireEtape.numeroEtape > 2 &&
                  preinscription.data.formulaire
                    .licencePreinscriptionFormulaireEtape.numeroEtape < 9
              "
              :steps="demoSteps"
              :preinscription="preinscription"
              :token="token"
              @completed-step="completeStep"
              @active-step="isStepActive"
              @stepper-finished="alert"
            >
            </horizontal-stepper>

            <RemerciementsPreinscription
              v-if="
                preinscription.data.formulaire.validation === '111111110' &&
                  preinscription.data.statut !== 'AE'
              "
              :token="token"
            />

            <RemerciementsPreinscriptionASTT
              v-if="preinscription.data.formulaire.validation === '111111111'"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MutationPreinscription from "@/components/MutationPreinscription.vue";
import HorizontalStepper from "@/components/extensions/HorizontalStepper.vue";
import GestionASTTPreinscription from "@/components/GestionASTTPreinscription.vue";
import RemerciementsPreinscription from "@/components/RemerciementsPreinscription.vue";
import RemerciementsPreinscriptionASTT from "@/components/RemerciementsPreinscriptionASTT.vue";

// This components will have the content for each stepper step.
import JeSuisPage from "@/components/pages/JeSuisPage.vue";
import JeSouhaitePage from "@/components/pages/JeSouhaitePage.vue";
import MesJustificatifsPage from "@/components/pages/MesJustificatifsPage.vue";
import JeMassurePage from "@/components/pages/JeMassurePage.vue";
import JeVerifiePage from "@/components/pages/JeVerifiePage.vue";
import JeMengagePage from "@/components/pages/JeMengagePage.vue";

export default {
  components: {
    HorizontalStepper,
    MutationPreinscription,
    GestionASTTPreinscription,
    RemerciementsPreinscription,
    RemerciementsPreinscriptionASTT
  },
  props: {
    preinscription: Object,
    token: String
  },
  data() {
    return {
      demoSteps: [
        {
          icon: require("@/assets/user-plus.png"),
          number: "1",
          name: "first",
          title: "JE SUIS",
          component: JeSuisPage,
          completed: false
        },
        {
          icon: require("@/assets/thumbs-up.png"),
          number: "2",
          name: "second",
          title: "JE SOUHAITE",
          component: JeSouhaitePage,
          completed: false
        },
        {
          icon: require("@/assets/file-text.png"),
          number: "3",
          name: "third",
          title: "JE PRODUIS MES JUSTIFICATIFS",
          component: MesJustificatifsPage,
          completed: false
        },
        {
          icon: require("@/assets/book.png"),
          number: "4",
          name: "third",
          title: "JE M'ASSURE",
          component: JeMassurePage,
          completed: false
        },
        {
          icon: require("@/assets/check-square.png"),
          number: "5",
          name: "third",
          title: "JE VÉRIFIE",
          component: JeVerifiePage,
          completed: false
        },
        {
          icon: require("@/assets/shuffle.png"),
          number: "6",
          name: "third",
          title: "JE M'ENGAGE",
          component: JeMengagePage,
          completed: false
        }
      ]
    };
  },
  methods: {
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.demoSteps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.demoSteps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    // Executed when @stepper-finished event is triggered
    // alert(payload) {
    alert() {
      // alert("end");
    }
  }
};
</script>

<style>
.container {
  max-width: 100% !important;
  padding: 0 !important;
}

.stepper-box .top .steps-wrapper .step .step-title h4 {
  font-family: Lato;
  font-size: 16px;
  color: #000000 !important;
}
</style>
